import Api from './api.js';

export default {
    newSystem (data) {
        return Api().post('systems', data);
    },
    getSystems (data) {
        return Api().get('systems', { params: data });
    },
    deleteSystem (data) {
        return Api().delete('systems', { params: data });
    },
    updateSystem (data) {
        return Api().put('systems', data);
    },
    getEconomyGroups (data) {
        return Api().get('systems', { params: data });
    }
};
